import React from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { CalendarDays } from "lucide-react";

import { DASHBOARD_CARD_MAX_ITEMS } from "../../../../../constants/dashboard-limits.ts";
import { Card } from "../../../../shared/card/card.tsx";
import { LeaveTypeLabel } from "../../../../shared/leave-type-label/leave-type-label.tsx";
import { Avatar, Button } from "../../../../ui/index.ts";
import { formatToMonthDay } from "../../../../../utils/helpers.ts";

import { useTodayLeaves } from "../../../../../hooks/use-today-leaves.ts";

import styles from "./team-availability-card.module.css";

export function TeamAvailabilityCard() {
  const navigate = useNavigate();
  const { data, loading } = useTodayLeaves();

  const displayMembers = data.slice(0, DASHBOARD_CARD_MAX_ITEMS);

  const count = displayMembers.length;
  const memberLabel = count === 1 ? "Member" : "Members";

  return (
    <Card
      variant="default"
      padding="5xl"
      className={styles.teamAvailabilityCard}
    >
      <header className={styles.header}>
        <div className={styles.titleBlock}>
          <h2 className={clsx("heading-sm", styles.title)}>
            Team Availability
          </h2>
          <p className={clsx("sub-heading-sm", styles.subtitle)}>
            Out of office today
          </p>
        </div>
        <p className={clsx("sub-heading-sm", styles.memberCount)}>
          {count} {memberLabel}
        </p>
      </header>

      <ul className={styles.list}>
        {!loading &&
          displayMembers.map((item) => (
            <li key={item.laveId} className={styles.row}>
              <Avatar name={item.name} size="md" className={styles.avatar} />
              <div className={styles.identity}>
                <p className={clsx("heading-xs", styles.name)}>{item.name}</p>
                <p className={clsx("sub-heading-sm", styles.role)}>
                  {item.designation}
                </p>
              </div>
              <div className={styles.status}>
                <LeaveTypeLabel
                  variant="leave"
                  label={item.typeOfLeave}
                  className={styles.leaveLabel}
                />
                <p className={clsx("sub-heading-sm", styles.date)}>
                  {formatToMonthDay(item.startDate)}
                </p>
              </div>
            </li>
          ))}
      </ul>

      <Button
        type="button"
        variant="muted-outline"
        fullWidth
        startIcon={<CalendarDays size={18} aria-hidden />}
        className={styles.footerButton}
        onClick={() => navigate("/dashboard/team-availability")}
      >
        View Full Team Calendar
      </Button>
    </Card>
  );
}